import { useMemo } from 'react';

import { TriangleAlert } from 'lucide-react';

import UpgradeToPremiumButton from '@/features/_shared/UpgradeToPremium/UpgradeToPremiumButton';
import {
  ExpiredBannerType,
  useExpiredBannerContent
} from '@/features/profile/hooks/useExpiredBannerContent';
import { formatDaysLeft } from '@/shared/lib/format/formatString';

export const ExpiredBanner = () => {
  const banner = useExpiredBannerContent();

  const content = useMemo(() => {
    if (!banner) return;
    switch (banner.type) {
      case ExpiredBannerType.expired:
        return (
          <>
            <p>You no longer have access. Upgrade now for full access.</p>
            <UpgradeToPremiumButton type='expired' />
          </>
        );
      case ExpiredBannerType.trialEndingSoon:
        return (
          <>
            <p>
              Your trial ends in <strong>{formatDaysLeft(banner.daysLeft)}</strong>
            </p>
            <UpgradeToPremiumButton type='expired' />
          </>
        );
      case ExpiredBannerType.subscriptionEndingSoon:
        return (
          <>
            <div className='my-2 flex items-center gap-4'>
              <TriangleAlert className='size-16 shrink-0' />
              <div className='max-w-[650px]'>
                <h2 className='mb-1.5 text-base font-bold'>
                  Your {banner.subscription} subscription is ending soon
                </h2>
                <p>
                  Your GX Go {banner.subscription} plan will expire in{' '}
                  <strong>{formatDaysLeft(banner.daysLeft)}</strong>. Renew now to maintain
                  uninterrupted access to premium features.
                </p>
              </div>
            </div>
            <UpgradeToPremiumButton type='manage' />
          </>
        );
    }
  }, [banner]);

  return (
    content && (
      <section className='mb-6 flex items-center justify-between gap-4 bg-gx-response px-6 py-2'>
        {content}
      </section>
    )
  );
};
